var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.needTruncate?_vm.value:''}},[_vm._v(_vm._s(_vm.truncatedValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }